import { varAlpha } from 'minimal-shared/utils';

import Stack from '@mui/material/Stack';
import { styled } from '@mui/material/styles';
import IconButton from '@mui/material/IconButton';
import SwipeableDrawer from '@mui/material/SwipeableDrawer';

import { Iconify } from 'src/components/iconify';

import { DetailsReview } from './';

// ----------------------------------------------------------------------

const Puller = styled('div')(({ theme }) => ({
  width: 50,
  height: 6,
  marginTop: 12,
  borderRadius: 3,
  marginBottom: 12,
  backgroundColor:
    theme.palette.mode === 'light' ? theme.palette.grey[400] : theme.palette.common.white,
}));

export function ReviewDrawer({ id, collection, reviewHook, showReview }) {
  const { value: open, onFalse: onClose, onTrue: onOpen } = showReview;

  return (
    <SwipeableDrawer
      open={open}
      anchor="bottom"
      onOpen={onOpen}
      disableDiscovery
      onClose={onClose}
      disableSwipeToOpen
      disableBackdropTransition
      slotProps={{ paper: { sx: { width: 1, height: 0.9 } } }}
    >
      <Stack
        direction="row"
        justifyContent={{ xs: 'center', md: 'flex-end' }}
        sx={[
          (theme) => ({
            top: 0,
            zIndex: 999,
            position: 'sticky',
            ...theme.mixins.bgBlur({ color: varAlpha(theme.vars.palette.background.paper, 0.48) }),
          }),
        ]}
      >
        <IconButton
          onClick={onClose}
          sx={{ py: 0.5, m: 0.5, display: { xs: 'none', sm: 'block' } }}
        >
          <Iconify icon="material-symbols:close" />
        </IconButton>

        <Puller sx={{ display: { sm: 'none' } }} />
      </Stack>

      <DetailsReview id={id} collection={collection} reviewHook={reviewHook} />
    </SwipeableDrawer>
  );
}
